import Header from "../components/header";
import Footer from "../components/footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const PaymentPolicy = () => {
  return (
    <div className="flex flex-col w-full min-h-screen">
      <Header />
      <div className="bg-[#031602] flex-1 pt-20">
        <div className="container mx-auto px-4 py-8 text-white">
          <div className="rounded-lg">
            <h1 className="text-4xl font-medium pb-10 text-center bg-gradient-to-b from-white to-[#50B553] bg-clip-text text-transparent relative">
              Chính sách thanh toán
            </h1>
          </div>
          {/* main content */}
          <div className="text-base font-light flex flex-col gap-5">
            <div className="content-header">
              <p>
                Để đảm bảo mọi quyền lợi cho khách hàng, Chatme có chính sách
                mua hàng rõ ràng và luôn có đội ngũ chăm sóc khách hàng 24/7.
                Ngay khi nhận được liên hệ, yêu cầu tư vấn hoặc thông tin đăng
                ký dịch vụ trực tuyến, chúng tôi sẽ nhanh chóng liên lạc lại qua
                điện thoại hoặc email để cung cấp thêm thông tin chi tiết.{" "}
              </p>
            </div>
            <div className="content-subheader">
              <p>
                Chatme.vn hỗ trợ thanh toán chuyển khoản Ngân hàng và thanh toán
                trực tiếp bằng cách tuân theo chính sách sau:
              </p>
            </div>
            {/* section 1 */}
            <div>
              <h5 className="font-medium">1. Chính sách giao dịch</h5>
              <p>
                Khách hàng có thể đăng ký gói cước/mua hoặc sử dụng nội dung
                thông qua các kênh cung cấp của dịch vụ được mô tả chi tiết tại
                trang web Chatme.
              </p>
            </div>
            {/* section 2 */}
            <div>
              <h5 className="font-medium">2. Chính sách thanh toán</h5>
              <p>
                Khi thực hiện đăng ký gói cước/mua hoặc tải nội dung hoặc thực
                hiện các giao dịch vụ tính phí khác, Chatme sẽ căn cứ trên các
                giao dịch mà khách hàng thực hiện để tiến hành trừ tiền trên
                từng giao dịch. Chatme sử dụng các dịch vụ, hệ thống thanh toán
                tích hợp nhiều tính năng thông minh, chế độ bảo mật cao để đảm
                bảo thông tin cá nhân, đảm bảo an toàn thanh toán của khách
                hàng. Chatme sẽ không tính tiền cho đến khi giao dịch được hoàn
                tất.
              </p>
            </div>
            {/* section contact */}
            <div>
              <p>Thông tin tài khoản công ty:</p>
              <ul className="ml-8">
                <li className="flex gap-2 items-center">
                  <img
                    src="/media/images/icon/credit-card.png"
                    alt="credit card icon"
                    className="size-4"
                  />
                  <p>Số tài khoản: 55156666</p>
                </li>
                <li className="flex gap-2 items-center">
                  <img
                    src="/media/images/icon/bank.png"
                    alt="bank icon"
                    className="size-4"
                  />
                  <p>
                    Ngân hàng: Ngân hàng cổ phần Thương mại Kỹ thương Việt Nam
                  </p>
                </li>
                <li className="flex gap-2 items-center">
                  <FontAwesomeIcon
                    icon={faUser}
                    className="size-4r3333333 text-blue-400"
                    alt="user icon"
                  />
                  <p>Chủ tài khoản: CTCP GIAI PHAP VA CN GD CYBERUNI</p>
                </li>
              </ul>
            </div>
            {/* section 3 */}
            <div>
              <h5 className="font-medium">
                3. Chính sách bảo hành, đổi trả và hoàn tiền
              </h5>
              <p>
                Ngay khi hệ thống nhận được lệnh tải/đăng ký hợp lệ, hệ thống sẽ
                ngay lập tức ghi nhận chính sách thuê bao được hưởng trên dịch
                vụ hoặc gửi nội dung khách hàng đã mua về thiết bị của khách
                hàng. Chatme không áp dụng chính sách bảo hành, đổi trả sản phẩm
                khi nội dung đã được chuyển đến thiết bị của Khách hàng thành
                công. Tất cả các giao dịch đã nhận được thông báo thành công đều
                không được hoàn trả phí từ hệ thống trong mọi trường hợp. Trong
                trường hợp giao dịch lỗi, hệ thống đã tiến hành trừ tiền thành
                công trong tài khoản của khách hàng mà khách hàng không nhận
                được nội dung mình đã mua hoặc không sử dụng được chính sách mà
                thuê bao được hưởng theo gói cước đã đăng ký, hệ thống sẽ gửi
                lại nội dung hoặc bù lại số ngày sử dụng cho khách hàng tương
                ứng với nội dung bị lỗi hoặc số ngày bị gián đoạn sử dụng.
              </p>
            </div>
            {/* section 4 */}
            <div>
              <h5 className="font-medium">
                4. Thời gian cung cấp dịch vụ sau khi đặt hàng
              </h5>
              <ul>
                <p>
                  Việc cung cấp dịch vụ tại website Chatme.vn sẽ được thực hiện
                  tự động và ngay lập tức sau khi thanh toán thành công, cụ thể
                  như sau:
                </p>
                <li className="list-disc list-inside indent-4">
                  Dịch vụ kích hoạt tự động: Ngay sau khi hệ thống xác nhận bạn
                  đã thanh toán thành công 1 trong 4 gói, tài khoản của bạn sẽ
                  được kích hoạt quyền truy cập, sử dụng nội dung đã đăng ký mà
                  không cần chờ đợi.
                </li>
                <li className="list-disc list-inside indent-4">
                  Giao dịch gói dịch vụ định kỳ: Thời gian sử dụng gói được tính
                  theo chu kỳ (1 tháng) kể từ thời điểm kích hoạt thành công và
                  được gia hạn tự động nếu khách hàng tiếp tục thanh toán.
                </li>
                <li className="list-disc list-inside indent-4">
                  Trường hợp xử lý thủ công: Trong một số trường hợp đặc biệt
                  (ví dụ: yêu cầu cấu hình riêng, kích hoạt dịch vụ theo gói
                  doanh nghiệp), thời gian xử lý có thể kéo dài từ 24h – 48h làm
                  việc. Bộ phận chăm sóc khách hàng sẽ chủ động liên hệ và thông
                  báo cụ thể.
                </li>
              </ul>
            </div>
            {/* seciton note */}
            <div>
              <p>
                Lưu ý: Khách hàng cần đảm bảo cung cấp đầy đủ và chính xác thông
                tin tài khoản khi đăng ký dịch vụ để tránh trường hợp chậm trễ
                trong quá trình kích hoạt. Nếu sau 24 giờ kể từ khi thanh toán
                mà dịch vụ vẫn chưa được kích hoạt, vui lòng liên hệ với bộ phận
                hỗ trợ Chatme.vn để được xử lý ngay.
              </p>
            </div>
            {/* section support */}
            <div>
              <p>Thông tin hỗ trợ:</p>
              <h5 className="font-medium">Email: support@cyberuni.vn</h5>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentPolicy;
